(function () {
  function initContactBubble() {
    var toggle = document.querySelector('[data-iv-contact-toggle]');
    var panel = document.querySelector('[data-iv-contact-panel]');
    var teaser = document.querySelector('[data-iv-contact-teaser]');
    if (!toggle || !panel) return;

    function setOpen(open) {
      panel.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (teaser && open) teaser.classList.add('is-hidden');
    }

    toggle.addEventListener('click', function () {
      setOpen(!panel.classList.contains('is-open'));
    });

    if (teaser) {
      teaser.addEventListener('click', function () {
        setOpen(true);
      });
    }

    document.addEventListener('click', function (event) {
      if (!panel.classList.contains('is-open')) return;
      if (panel.contains(event.target) || toggle.contains(event.target) || (teaser && teaser.contains(event.target))) return;
      setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactBubble);
  } else {
    initContactBubble();
  }
})();
